import { Plan } from 'src/services/responseTypes/displayPlansResponse';
import {
  purchasePlan,
  purchasePlanResponse
} from 'src/services/responseTypes/purchasePlanResponse';
import { Countrylist } from 'src/services/responseTypes/singleLaunchResponse';
import {
  AssetDetails,
  SinglePlayResponse
} from 'src/services/responseTypes/singlePlayResponse';
import { TvodRentals } from 'src/store/interface';

import { tvodConstants } from '../constants/stringConstants';

type PaymentProviderFlags = {
  [providerName: string]: boolean;
};

// check if a given asset is tvod or not
export const checkIsTvod = (businessType: string) => {
  const { tvod, tvodDownloadable, tvodPremium } = tvodConstants;
  let isTvod = false;
  if (businessType) {
    isTvod = [tvod, tvodDownloadable, tvodPremium].includes(
      businessType.toLocaleLowerCase()
    );
  }
  return isTvod;
};
export const getTVODPrice = (
  countryListTvodData: Countrylist | undefined,
  tier: any
) => {
  const currency = countryListTvodData?.tvod_tiers?.currency;
  const tvodTiers =
    countryListTvodData?.tvod_tiers?.tiers &&
    countryListTvodData?.tvod_tiers?.tiers.length > 0
      ? countryListTvodData?.tvod_tiers?.tiers
      : [];
  const data =
    tier && tvodTiers.length
      ? tvodTiers.filter((item: any) => tier === item.name)
      : [];
  let price = 0;
  if (data.length) {
    price = data[0].value;
  }

  return {
    currency,
    price
  };
};

export const getPlanMatchingTier = (
  tier: string | undefined,
  tvodRentals: purchasePlanResponse
) => {
  return (
    tvodRentals &&
    Object.values(tvodRentals).filter((plan) => plan?.tier === tier)
  );
};

export const prepareTvodPaymentData = (
  tvodPlanData: purchasePlan[],
  singlePlayDetailsMovie: AssetDetails | undefined,
  licenseExpiryDate?: string
) => {
  let selectPlan: any;
  if (tvodPlanData && Array.isArray(tvodPlanData) && tvodPlanData.length) {
    const plan = tvodPlanData[0];
    const paymentProviderFlags = setPaymentProviderFlags(plan);

    const consumptionUrl =
      singlePlayDetailsMovie?.slug || singlePlayDetailsMovie?.web_url;
    selectPlan = setData(plan, paymentProviderFlags, true);
    selectPlan.TVOD_title =
      singlePlayDetailsMovie?.title || singlePlayDetailsMovie?.original_title;
    selectPlan.content_owner = singlePlayDetailsMovie?.content_owner;
    selectPlan.asset_id = singlePlayDetailsMovie?.id;
    selectPlan.urlSlug = consumptionUrl;
    selectPlan.tier = singlePlayDetailsMovie?.tier;
    selectPlan.tvod_content_details = {
      original_title:
        singlePlayDetailsMovie?.original_title || singlePlayDetailsMovie?.title,
      billing_type: singlePlayDetailsMovie?.billing_type,
      business_type: singlePlayDetailsMovie?.business_type,
      genre: singlePlayDetailsMovie?.genre,
      genres: singlePlayDetailsMovie?.genres,
      actors: singlePlayDetailsMovie?.actors,
      duration: singlePlayDetailsMovie?.duration,
      release_date: singlePlayDetailsMovie?.release_date,
      asset_subtype: singlePlayDetailsMovie?.asset_subtype,
      asset_type: singlePlayDetailsMovie?.asset_type,
      subtitle_languages: singlePlayDetailsMovie?.subtitle_languages,
      channels: singlePlayDetailsMovie?.channels,
      languages: singlePlayDetailsMovie?.languages,
      audio_languages: singlePlayDetailsMovie?.audio_languages,
      id: singlePlayDetailsMovie?.id,
      licenseExpiryDate: licenseExpiryDate,
      tags: singlePlayDetailsMovie?.tags
    };
  }
  return selectPlan;
};

export const setPaymentProviderFlags = (plan: purchasePlan) => {
  const paymentProviderFlags: PaymentProviderFlags = {};
  for (let j = 0; j < plan?.payment_providers?.length; j += 1) {
    paymentProviderFlags[plan.payment_providers[j].name] = true;
  }
  return paymentProviderFlags;
};

export const setData = (
  data: any,
  flags: PaymentProviderFlags,
  isTvod = false
) => {
  const {
    BillDesk,
    PayTM,
    PayU,
    Mobikwik,
    Phonepe,
    Amazonpay_new: AmazonpayNew,
    Google,
    Qwikcilver,
    PaytmQR
  } = flags;
  return {
    pack: data.title || '',
    price:
      data.actual_price || // dominate node from "display" API over "plans" API
      data.actualPrice ||
      data.sell_price || // dominate node from "display" API over "plans" API
      data.sellPrice ||
      data.price,
    currency: data.currency || '',
    pack_id: data.id || '',
    start_date: data.start || '',
    end_date: data.end || '',
    billing_frequency: data.billingFrequency || data.billing_frequency || '',
    /* asset_types:
        data.asset_types && isArray(data.asset_types)
          ? data.asset_types.sort().join(',')
          : '', */
    country: data.country || '',
    device_number:
      data.numberOfSupportedDevices || data.number_of_supported_devices || -1,
    all_paymentProviders: data.paymentProviders || data.payment_providers,
    promotions: data.promotions,
    auto_renewal: data.recurring,
    tv_lang: data.tv_show_audio_languages,
    channel_lang: data.channel_audio_languages,
    movie_lang: data.movie_audio_languages,
    description: data.description || '',
    pack_type: isTvod
      ? 'TVOD'
      : (data.tv_show_audio_languages &&
          data.tv_show_audio_languages.length > 0) ||
        (data.movie_audio_languages && data.movie_audio_languages.length > 0) ||
        (data.channel_audio_languages &&
          data.channel_audio_languages.length > 0)
      ? 'RSVOD'
      : 'SVOD',
    // pack_type: data.subscriptionPlanType || data.subscription_plan_type,
    promo_code: null,
    BillDesk,
    PayTM,
    PayU,
    Mobikwik,
    Phonepe,
    AmazonpayNew,
    Google,
    Qwikcilver,
    PaytmQR,
    billing_type: data.billingType || data.billing_type || '',
    allowed_playback_duration:
      data.allowedPlaybackDuration || data.allowed_playback_duration || '',
    offers: data.offers || [],
    tvodPackDetails: data.tvodPackDetails || {},
    duration_text:
      data.display_price || // dominate node from "display" API over "plans" API
      data.displayPrice ||
      data.duration_text ||
      data.durationText ||
      '',
    original_price: data.original_price || '',
    suggestionTag: data.suggession_tag,
    title: data.title,
    features: data.features,
    purchaseAllowed: data.purchase_allowed || false,
    priority: data.priority,
    isDefault: data.isDefault || false,
    duration: data.duration,
    discount: data.discount || 0 // for handling cohort discount obj
  };
};
